import React, { Suspense } from 'react';
import Loading from 'app/components/LayOut/Loading.jsx';
import ErrorBoundary from 'app/components/ErrorBoundary.jsx';

export default (loader) => {
    const LazyComponent = React.lazy(loader);
    return (props) => (
        <ErrorBoundary>
            <Suspense fallback={<Loading />}>
                <LazyComponent {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};
